export default {
  loading: true,
  isLoggedIn: !!localStorage.getItem('token'),
  userCommonData: {
    id: '',
    role: 0
  }
}
